import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AccountHero } from "@/components/account/AccountHero";
import { ProfileCard } from "@/components/account/ProfileCard";
import { ConnectedCard, PasswordCard } from "@/components/account/SecurityCard";
import { SubscriptionCard } from "@/components/account/SubscriptionCard";
import { NotificationsCard, PreferencesCard } from "@/components/account/PreferencesCard";
import { DangerCard } from "@/components/account/DangerCard";
import "@/components/account/account.css";

export default function Account() {
  const { setSession } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { api.get("/account").then((r) => setData(r.data)).catch(() => setError(true)); }, []);
  const saved = (view) => {
    setData(view);
    api.get("/auth/me").then((r) => setSession(r.data)).catch(() => {});
  };
  if (error) return <p className="as-loading" data-testid="account-error">Could not load your account. Refresh to try again.</p>;
  if (!data) return <p className="as-loading" data-testid="account-loading">Loading your account…</p>;
  return (
    <div className="as-root" data-testid="account-page">
      <header className="as-heading">
        <span className="as-eyebrow">ACCOUNT SETTINGS</span>
        <h1>My <span>account</span></h1>
        <p>Manage your profile, security, subscription and preferences.</p>
      </header>
      <AccountHero data={data} onSaved={saved} />
      <div className="as-grid">
        <ProfileCard data={data} onSaved={saved} />
        <SubscriptionCard data={data} />
        <PasswordCard data={data} onSaved={saved} />
        <PreferencesCard data={data} onSaved={saved} />
        <NotificationsCard data={data} onSaved={saved} />
        <ConnectedCard data={data} />
        <DangerCard data={data} />
      </div>
    </div>
  );
}
